import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/frontru/nesterenko/src/views/about/index.tsx");
